"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DDP_SURCHARGE_SERVICE_LEVELS = exports.ServiceLevel = void 0;
var ServiceLevel;
(function (ServiceLevel) {
    ServiceLevel["OneDayNonFastTag"] = "1 Day (Non Fast Tag)";
    ServiceLevel["TwoDayNonFastTag"] = "2 Day (Non Fast Tag)";
    ServiceLevel["ThreeDayNonFastTag"] = "3 Day (Non Fast Tag)";
    ServiceLevel["StandardNonFastTag"] = "Standard (Non Fast Tag)";
    ServiceLevel["AKHIOtherNonFastTag"] = "AK/HI/Other (Non Fast Tag)";
    ServiceLevel["WalmartFastTagStandard"] = "Walmart Fast Tag / Standard";
    ServiceLevel["WebsiteFastTag"] = "Website Fast Tag";
    ServiceLevel["Military"] = "US Military (Non Fast Tag)";
    ServiceLevel["eBayFastTagStandard"] = "eBay Fast Tag / Standard";
    ServiceLevel["WishFastTagStandard"] = "Wish Fast Tag / Standard";
    ServiceLevel["GoogleFastTagStandard"] = "Google Fast Tag / Standard";
    ServiceLevel["TargetStandard"] = "Target Standard";
    /**
     * DDP service levels
     */
    ServiceLevel["WorldwideStandardDDP"] = "Worldwide Standard DDP";
    ServiceLevel["WorldwideExpressDDP"] = "Worldwide Express DDP";
    ServiceLevel["WorldwideExpeditedDDP"] = "Worldwide Expedited DDP";
    ServiceLevel["WorldwidePartnerDeliveredDutyPaid"] = "Worldwide Partner Delivered Duty Paid";
    ServiceLevel["WorldwidePartnerDeliveredDutyUnpaid"] = "Worldwide Partner Delivered Duty Unpaid";
    ServiceLevel["WorldwideStandardDeliveredDutyUnpaid"] = "Worldwide Standard Delivered Duty Unpaid";
    ServiceLevel["ShopifyPromise"] = "Shopify Promise";
    /**
     * new service levels for 2024 pricing
     */
    ServiceLevel["PriorityOneDay"] = "Expedited 1 Day";
    ServiceLevel["PriorityTwoDay"] = "Expedited 2 Day";
    ServiceLevel["PriorityThreeDay"] = "Expedited 3 Day";
    ServiceLevel["Flexpedited"] = "Flexpedited";
    ServiceLevel["Standard"] = "Standard";
    ServiceLevel["NotSet"] = "Not Set";
    /**
     * @deprecated as of Jun 20, 2023
     */
    ServiceLevel["WorldwideStandard"] = "Worldwide Standard";
    /**
     * @deprecated as of Feb 19, 2022
     */
    ServiceLevel["GoogleFastTag"] = "Google Fast Tag";
    /**
     * @deprecated as of Feb 19, 2022
     */
    ServiceLevel["WishFastTag"] = "Wish Fast Tag";
    /**
     * @deprecated as of Feb 19, 2022
     */
    ServiceLevel["eBayFastTag"] = "eBay Fast Tag";
    /**
     * @deprecated as of Sep 9, 2021
     */
    ServiceLevel["CanadaStandard"] = "Canada Standard";
    /**
     * @deprecated as of Feb 27, 2021
     */
    ServiceLevel["ThreeDay"] = "3 Day";
    /**
     * @deprecated as of Feb 27, 2021
     */
    ServiceLevel["TwoDay"] = "2 Day";
    /**
     * @deprecated as of Feb 27, 2021
     */
    ServiceLevel["WalmartTwoDay"] = "Walmart 2 Day";
    /**
     * @deprecated as of Feb 27, 2021
     */
    ServiceLevel["WalmartThreeDay"] = "Walmart 3 Day";
    /**
     * @deprecated as of Feb 27, 2021
     */
    ServiceLevel["WalmartStandard"] = "Walmart Standard";
    /**
     * @deprecated as of Feb 27, 2021
     */
    ServiceLevel["AmazonPrime"] = "Amazon Prime";
    /**
     * @deprecated as of Feb 27, 2021
     */
    /**
     * @deprecated as of Feb 27, 2021
     */
    ServiceLevel["eBayThreeDay"] = "eBay 3 Day Pilot";
    /**
     * @deprecated as of Feb 27, 2021
     */
    ServiceLevel["OneDay"] = "1 Day";
    /**
     * @deprecated as of Feb 27, 2021
     */
    ServiceLevel["AKHIOther"] = "AK/HI/Other";
    /**
     * @deprecated as of Feb 27, 2021
     */
    ServiceLevel["ShopifyTwoDay"] = "Shopify 2 Day";
    /**
     * @deprecated as of Feb 27, 2021
     */
    ServiceLevel["WebsiteTwoDay"] = "Website 2 Day";
    /**
     * @deprecated as of Feb 27, 2021
     */
    ServiceLevel["WishExpress"] = "Wish Express";
    /**
     * @deprecated as of Feb 27, 2021
     */
    ServiceLevel["WishTwoDay"] = "Wish 2 Day";
    /**
     * @deprecated as of Feb 27, 2021
     */
    ServiceLevel["GoogleTwoDay"] = "Google 2 Day";
})(ServiceLevel = exports.ServiceLevel || (exports.ServiceLevel = {}));
exports.DDP_SURCHARGE_SERVICE_LEVELS = [
    ServiceLevel.WorldwidePartnerDeliveredDutyPaid,
    ServiceLevel.WorldwidePartnerDeliveredDutyUnpaid,
];
//# sourceMappingURL=ServiceLevel.js.map